import { ReactNode } from 'react';

// material-ui
import { ChipProps } from '@mui/material';
import { GenericCardProps } from './root';

import { Rights, User } from '../graphql/types';
import { BadgeCounts } from '../layout/Dashboard/Drawer/DrawerContent/Navigation/NavItem';

export enum NavActionType {
  FUNCTION = 'function',
  LINK = 'link'
}

// ==============================|| MENU TYPES ||============================== //

export type NavActionProps = {
  type: NavActionType;
  label: string;
  function?: any;
  url?: string;
  target?: boolean;
  icon: GenericCardProps['iconPrimary'] | string;
};

export type NavItemType = {
  breadcrumbs?: boolean;
  caption?: ReactNode | string;
  children?: NavItemType[];
  elements?: NavItemType[];
  chip?: ChipProps;
  color?: 'primary' | 'secondary' | 'default' | undefined;
  disabled?: boolean;
  external?: boolean;
  isDropdown?: boolean;
  icon?: GenericCardProps['iconPrimary'] | string;
  id?: string;
  link?: string;
  search?: string;
  target?: boolean;
  title?: ReactNode | string;
  type?: string;
  url?: string | undefined;
  actions?: NavActionProps[];
  hidden?: boolean;
  avatarForUser?: User;
  rights?: Rights[];
  oneOfRights?: Rights[];
  badges?: BadgeCounts[];
};

export type LinkTarget = '_blank' | '_self' | '_parent' | '_top';

export type MenuProps = {
  /**
   * Indicate if dashboard layout menu open or not
   */
  isDashboardDrawerOpened: boolean;

  /**
   * Indicate if component layout menu open or not
   */
  isComponentDrawerOpened: boolean;

  openItem: string[];
  openComponent: string;
  selectedID: string | null;
  drawerOpen: boolean;
  componentDrawerOpen: boolean;
  menuDashboard: NavItemType;
  error: null;
};
